import { Identificable, LabelledEntity } from 'shared/types/commonView';
import { LocaleCountryAndLanguageCode } from 'shared/types/locale';

export type FieldValueOnView = LabelledEntity & {
  processes: string[];
  canEditTranslations: boolean;
  valueTranslations: FieldValueTranslationOnView[];
  createdByClientId?: string;
};

export interface CreateFieldValueOnView {
  _id?: undefined;
  localId: string;
  label: string;
  processes: string[];
  canEditTranslations: boolean;
  valueTranslations: FieldValueTranslationOnView[];
  createdByClientId?: string;
}

export type EditFieldValueOnView = Identificable & {
  processes: string[];
  valueTranslations?: FieldValueTranslationOnView[];
  createdByClientId?: string;
};

export function isCreateFieldValueOnView(
  fieldValue: CreateFieldValueOnView | FieldValueOnView
): fieldValue is CreateFieldValueOnView {
  return fieldValue._id === undefined;
}

/**
 * Draft values (not yet persisted) are identified by `localId`;
 * persisted values are identified by their server `_id`.
 */
export function getFieldValueIdentifier(
  fieldValue: CreateFieldValueOnView | FieldValueOnView
): string {
  return isCreateFieldValueOnView(fieldValue)
    ? fieldValue.localId
    : fieldValue._id;
}

export type WorktypeOnView = FieldValueOnView;
export type HazardCategoryOnView = FieldValueOnView;
export type EnvironmentalAspectOnView = FieldValueOnView;
export type CorrectiveActionTypeOnView = FieldValueOnView;
export type DelayReasonOnView = FieldValueOnView;
export type IssueVerificationItemOnView = FieldValueOnView;
export type RejectionReasonOnView = FieldValueOnView;
export type RootCauseOnView = FieldValueOnView;
export type EffectOnView = FieldValueOnView;
export type CircumstanceOnView = FieldValueOnView;
export type ImpactOnView = FieldValueOnView;
export type DecisionToImposeFineOnView = FieldValueOnView;
export type SpilledSubstanceOnView = FieldValueOnView;
export type PriorityOnView = FieldValueOnView;
export type ProjectStageOnView = FieldValueOnView;
export type EmploymentTypeOnView = FieldValueOnView;
export type InjuryTypeOnView = FieldValueOnView;
export type InjuredBodyPartOnView = FieldValueOnView;
export type RequirementsOnView = FieldValueOnView;
export type InstallationBasisOnView = FieldValueOnView;
export type ConstructionProductDocumentsOnView = FieldValueOnView;
export type DeviceDocumentsOnView = FieldValueOnView;
export type AdditionalDocumentsOnView = FieldValueOnView;

export enum FieldValueType {
  fromRemote = 'fromRemote',
  toCreate = 'toCreate',
}

export interface FieldValueTranslationOnView {
  deleted: boolean;
  localeCode: LocaleCountryAndLanguageCode;
  value: string;
  _id: string;
  type: FieldValueType;
}
